import React from 'react';
import { Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import './theme/custom.css';
/* Theme variables */
//import './theme/variables.css';
import MainPage from './pages/MainPage';

const App: React.FC = () => (
	<IonApp style={{
		cursor: `url("${process.env.PUBLIC_URL}/assets/images/general/icons/mouse-idle.png"), auto`
	}}>
		<IonReactRouter>
			<IonRouterOutlet>
				{/* <Route path={process.env.PUBLIC_URL} component={MainPage} exact={true} /> */}
				<MainPage></MainPage>
			</IonRouterOutlet>
		</IonReactRouter>
	</IonApp>
);

export default App;
